import {createApp} from 'vue';
import queryString from "query-string";
import axios from "axios";
import formsMixin from "@/formsMixin";

let mailingSignupElements = document.getElementsByClassName('MailingSignup');

if (mailingSignupElements.length > 0) {
    for (let i = 0; i < mailingSignupElements.length; i++) {
        let elementID = mailingSignupElements[i].id;
        createApp({
            data() {
                return {
                    subscribed: false,
                    validationErrorMessage: '',
                }
            },
            mixins: [formsMixin],
            computed: {
                canSendSignup() {
                    if (this.loading === true) {
                        return false;
                    }
                    if (this.notUndefinedNullOrBlankString(this.email) === false) {
                        return false;
                    }
                    if (this.notUndefinedNullOrBlankString(this.fname) === false) {
                        return false;
                    }
                    if (this.notUndefinedNullOrBlankString(this.lname) === false) {
                        return false;
                    }
                    if (this.emailIsValid === false) {
                        return false;
                    }
                    if (this.recaptchaVerified !== true) {
                        return false;
                    }

                    return true;
                },
            },
            methods: {
                async sendSignup() {

                    this.validationHasRun = true;

                    await this.recaptchaVerify();

                    if (this.canSendSignup === true) {

                        this.loading = true;
                        this.apiError = false;

                        let urlParams = {
                            email: this.email,
                            fname: this.fname,
                            lname: this.lname,
                        };

                        let url = '/api/mailinglistsignup?' + queryString.stringify(urlParams);

                        try {
                            await axios.get(
                                url,
                                {
                                    headers: {
                                        'content-type': 'application/x-www-form-urlencoded'
                                    }
                                }
                            ).then((response) => {
                                let data = response.data;
                                if (data.status === 'failed') {
                                    this.apiError = true;
                                } else if (data.status === 'validationfailed') {
                                    this.apiError = false;
                                    this.validationErrorMessage = data.validationErrorMessage;
                                } else {
                                    this.subscribed = data.subscribed;
                                    Toastify({
                                        text: "You have been subscribed to our mailing list",
                                    }).showToast();

                                    let firstNameField = document.getElementById('RegisterFormFirstName');
                                    if (firstNameField !== undefined) {
                                        firstNameField.value = this.fname;
                                    }
                                    let lastNameField = document.getElementById('RegisterFormLastName');
                                    if (lastNameField !== undefined) {
                                        lastNameField.value = this.lname;
                                    }
                                    let emailField = document.getElementById('RegisterFormEmail');
                                    if (emailField !== undefined) {
                                        emailField.value = this.email;
                                    }
                                    window.closeMailchimpPopup();
                                    window.showRegisterPopup();
                                }
                                this.loading = false;
                            });

                        } catch (err) {
                            if (err.response) {
                                // The client was given an error response (5xx, 4xx)
                                console.log('The client was given an error response (5xx, 4xx)');
                            } else if (err.request) {
                                // The client never received a response, and the request was never left
                                console.log('The client never received a response, and the request was never left');
                            } else {
                                // Anything else
                                console.log('Other error');
                                console.log(err);
                            }
                            this.loading = false;
                            this.apiError = true;
                        }
                    }
                }
            }
        }).mount('#' + elementID);
    }
}